import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HomePage from './components/HomePage';
import CategoryPage from './components/CategoryPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/category/:categoryId" element={<CategoryPage />} />
          </Routes>
        </main>
        <footer className="footer">
          <div className="footer-content">
            <div className="copyright">
              © 2025 After Eight Cocktail Club. All rights reserved.<br/><br/> Designed and built by <a style={{textDecoration: 'none', color: '#e5f60d'}} href="https://team-heimdall.vercel.app/" target="_blank" rel="noopener noreferrer">Team Heimdall</a>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
